/* eslint-disable */

/*
 Common.js
 Requiring All Javascript in CommonJS
 */

// Requiring Common Less and Css Files, It all be combine to same Chuck
require('../less/common.less');
require('../less/profile.less');

window.i18n = require('./json_locale/' + LANGUAGE_CODE + '/djangojs.json');
require('./lib/django.i18n.js');

//expose jquery to Global Scope
window.jQuery = $ = require('jquery');

// Django Auto ajax csrf
require('./lib/django.cookie.js');

// Bootstrap JS Code, Will be available in all pages
require('bootstrap/js/dropdown.js');
require('bootstrap/js/collapse.js');
require('bootstrap/js/modal.js');
require('bootstrap/js/tab.js');
require('bootstrap/js/alert.js');

require('@pnotify/mobile/dist/PNotifyMobile.css');
require('@pnotify/core/dist/PNotify.css');
window.PNotify = require('@pnotify/core');
window.bootbox = require('bootbox.js/bootbox.js');

define(['jquery-validation'], function () {
  var dateValidate = function (year, mon) {
    var today = new Date();
    return year > today.getFullYear() || mon > today.getMonth() + 1;
  };

  $.extend($.validator.messages, {
    required: gettext('This field is required'),
    remote: gettext('Please fix this field.'),
    email: gettext('Please enter a valid email address.'),
    url: gettext('Please enter a valid URL.'),
    date: gettext('Please enter a valid date.'),
    dateISO: gettext('Please enter a valid date ( ISO ).'),
    number: gettext('Please enter a valid number.'),
    digits: gettext('Please enter only digits.'),
    creditcard: gettext('Please enter a valid credit card number.'),
    equalTo: gettext('Please enter the same value again.'),
    minlengthtrim: gettext('Please enter at least {0} characters'),
  });

  $.validator.setDefaults({
    errorElement: 'span',
    errorClass: 'help-block has-error',
    errorPlacement: function (error, el) {
      el.parent().parent().after(error);
    },
    onfocusout: function (el) {
      this.element(el);
      return true;
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-group').addClass('has-error').removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-group').removeClass('has-error').addClass(validClass);
    },
  });

  $.validator.addMethod('minlengthtrim', function (value, element, params) {
    return this.optional(element) || value.trim().length >= params;
  });

  $.validator.addMethod('requiredonly', function (value, element) {
    if (
      !this.optional(element) &&
      !($('.modal-content #id_country_code').val() == 'US' || $('.modal-content #id_country_code').val() == 'CA')
    )
      return false;
    return true;
  });
  $.validator.addMethod('depend', function (value, element, params) {
    if (($(element).val() == 'US' || $(element).val() == 'CA') && $('id_state') == '') {
      this.element($(params));
      return this.optional(element) || false;
    }
    return this.optional(element) || true;
  });
});

define(['jquery'], function ($) {
  require('spin.js/jquery.spin.js');

  var onToggle = function () {
    $(this).next().toggleClass('xs-m-l-230');
    $('.o-main').toggleClass('s-x-hidden');
  };

  $('#js-side-bar').on('show.bs.collapse', onToggle);
  $('#js-side-bar').on('hide.bs.collapse', onToggle);

  $.fn.toggleWaitingAnimate = function () {
    this.each(function () {
      var elm = $(this);
      if (!elm.attr('disabled')) {
        elm.attr('disabled', 'disabled');
        elm.addClass('button-load');
        if (elm.is('a')) {
          elm.prepend('<span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>');
        } else {
          elm.parent().append('<span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> ');
        }
      } else {
        elm.removeAttr('disabled');
        elm.removeClass('button-load');
        if (elm.is('a')) {
          elm.find('.glyphicon-refresh-animate').remove();
        } else {
          elm.parent().find('.glyphicon-refresh-animate').remove();
        }
      }
    });
    return this;
  };

  $(document.body)
    .on('show.bs.modal', function () {
      if (this.clientHeight <= window.innerHeight) {
        return;
      }
      var $body = $('body');
      var scrollbarWidth = function () {
        var a = document.createElement('div');
        a.className = 'modal-scrollbar-measure';
        $body.append(a);
        var b = a.offsetWidth - a.clientWidth;
        return $body[0].removeChild(a), b;
      };
      if (scrollbarWidth) {
        $('.navbar-fixed-top').css('margin-right', scrollbarWidth());
      }
    })
    .on('hide.bs.modal', function () {
      $('.navbar-fixed-top').css('margin-right', 0);
    });

  $(document).ready(function () {
    var $langMenu = $('#lang-form');
    if ($langMenu.length > 0) {
      $('#js-menu-options')
        .find('li')
        .on('click', function () {
          if (!$('#js-menu-options').hasClass('open')) return true;

          $langMenu.find('input[name=language]').val($(this).find('a').attr('data-lang'));
          $langMenu.submit();
          return false;
        });
    }
  });
});
